export function normalizeForSort(str: string): string {
	return str
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
}

export function startsWithSpecialChar(str: string): boolean {
	const normalized = normalizeForSort(str.trimStart())
	if (!normalized) return false
	return /^[^\p{L}\p{N}]/u.test(normalized)
}

export function compareSortValues(
	valueA: string,
	valueB: string,
	locale?: string,
): number {
	const a = normalizeForSort(valueA)
	const b = normalizeForSort(valueB)

	const aIsSpecial = startsWithSpecialChar(valueA)
	const bIsSpecial = startsWithSpecialChar(valueB)

	if (aIsSpecial && !bIsSpecial) return 1
	if (!aIsSpecial && bIsSpecial) return -1

	return a.localeCompare(b, locale, { numeric: true })
}
